import './Main.css'

import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { WizardData } from './Model'
import { goToAddFailurePage, StartAddFailurePage } from '@/pages/communal/machine/failures/add/Main'
import { Machine } from '@/services/model/machine'
import { MachineName } from '@/components/machine'
import { useNavigate } from 'react-router-dom'
import { MachineFailureCategory } from '@/services/repository/machines'

export interface SimpleUserGroup {
  id: string
  name: string
}

function getBatteryTransKey(percent: number): string {
  const base = 'machine.checklist.wizard.step6.soc_msg.'
  if (percent >= 60 && percent <= 100) {
    return base+"60_100"; // 60–100%
  } else if (percent >= 30 && percent < 60) {
    return base+"30_59"; // 30–59%
  } else if (percent >= 20 && percent < 30) {
    return base+"20_29"; // 20–29%
  } else if (percent < 20) {
    return base+"0_20"; // <20%
  }
  return ''
}

function getBatteryClass(percent: number) {
  if (percent >= 60 && percent <= 100) {
    return "soc-green"; // 60–100%
  } else if (percent >= 30 && percent < 60) {
    return "soc-yellow"; // 30–59%
  } else if (percent >= 20 && percent < 30) {
    return "soc-red"; // 20–29%
  } else if (percent < 20) {
    return "soc-red"; // <20%
  }
}

export const Step6 = ({ machine }: {
  machine: Machine
}) => {
  const { services, session, translates } = useAppContext()
  const navigate = useNavigate()
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <div>
    <h3>{translates.for('machine.checklist.wizard.step6.title')}</h3>
    <p className='desc'>
      {translates.for('machine.checklist.wizard.step6.description')}
    </p>

    {machine.params?.deviceData?.soc ? <p className={`${getBatteryClass(machine.params.deviceData.soc)} soc-box`}>
        <div>SOC: {machine.params?.deviceData?.soc}</div>
        <div>{translates.for(getBatteryTransKey(machine.params.deviceData.soc))}</div>
    </p> : null }
    
    <div className='btns'>
      <a className='btn btn-next main-btn' onClick={nextStep}>
        {translates.for('machine.checklist.wizard.step6.approve')}
      </a>
      <a className='btn btn-fail main-red-btn' onClick={() => {
        goToAddFailurePage({
          navigate,
          machineId: machine.id
        }, {
          category: MachineFailureCategory.Other
        })
      }}>
        {translates.for('machine.checklist.wizard.step6.fail')}
      </a>
    </div>

  </div>
}
